// Gegenereerd bestand - NIET BEWERKEN!
// WEL inchecken in Git!

export enum PlanningStatus {
    PlanningBehoefte = 'planningBehoefte',
    PlanningBevestigd = 'planningBevestigd',
    PlanningGarantiewerk = 'planningGarantiewerk',
    PlanningGeblokkeerd = 'planningGeblokkeerd',
    PlanningGepland = 'planningGepland',
    PlanningRegen = 'planningRegen',
    PlanningReservering = 'planningReservering',
    PlanningSlaapdag = 'planningSlaapdag',
    PlanningVerwerkt = 'planningVerwerkt',
}
